const _ = require('lodash')
import {generateFetchFieldListAction} from "../../../apps/KpModule/actions/api";

export const entity = {
    name: 'Refuge',
    fields: [
        'name',
        'address', 'additionalAddress', 'zipCode', 'city', 'country',
        {path: 'contacts', type: 'CUser', link : 'MTM', nullable: true},
        { path: 'lastUser', type: 'User', nullable: true },
        { path: 'lastModificationDate', type: 'date', nullable: true },
        {
            path: 'nbContacts',
            type: 'integer',
            fieldPath: ['contacts.id', 'contacts.state'],
            $f: async (organization, context, callback) => {
                const activeContacts = organization.contacts.filter(contact => contact.active)
                return callback(null, activeContacts.length)
            }
        },
    ],
    beforeSave: (object, oldObject, context, callback) => {
        object.lastUser = new global.ObjectID(context.user.id)
        object.lastModificationDate = new Date()
        callback(null, object, oldObject)
    }
}

export const module_ = {
    object: 'Refuge',
    tKey: 'refuge relais',
    category: {
        path: 'menuTitle_phoneBook',
        icon: 'notebook'
    },
    viewMap: {
        dt: [
            'name',
            'address',
            'zipCode',
            'city',
            {path: 'nbContacts'},
            { path: 'lastUser' },
            { path: 'lastModificationDate' }
        ],
        form: {
            fields: [
                {
                    path: 'organization',
                    editable: false,
                    display: 'fullName',
                    fieldPath: ['id', 'name', 'code', 'fullName'],
                    subscriptions: {
                        onChange: (newValue, oldValue, {store}) => {
                            store.dispatch(
                                generateFetchFieldListAction(
                                    "m-C-refuge.Refuge_contacts",
                                    store.getState,
                                    {data: {organizationId: newValue?.id}}
                                )
                            )
                        }
                    }
                },
                {path: 'name', required: true,},
                {path: 'address', placeholder: 'Renseigner l’adresse', required: true,},
                {path: 'additionalAddress', placeholder: 'Renseigner le complément d’adresse'},
                {path: 'zipCode', widthClassName: "col-xs-12 col-sm-6", placeholder: 'Renseigner le code postal', maxLength: 5, noSpaces: true, required: true, numerical: true},
                {path: 'city', widthClassName: "col-xs-12 col-sm-6", placeholder: 'Renseigner la ville', required: true},
                {path: 'country', default: 'France', hidden: true, disabled: true, required: true},
                {path: 'contacts', display: 'completeInfo', filters: ['byOrganizationId']}
            ]
        }
    }
}
